import React from 'react';
import PickupRequestReport from './PickupRequestReport';

const CustomerPickupRequestReport = () => (
  <PickupRequestReport requestType="CUSTOMER" title="Customer Pickup Request Report" />
);

export default CustomerPickupRequestReport;
